import { AvForm, AvField, AvInput } from 'availity-reactstrap-validation';
import React, { useEffect, useState } from 'react';
import toastr from 'toastr';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  CustomInput,
  FormGroup,
  Label,
  Row,
  Input,
} from 'reactstrap';
import useAttachement from '../../helpers/hooks/useAttachments';
import usePost from '../../helpers/hooks/usePost';
import { useHistory } from 'react-router-dom';
import useGet from '../../helpers/hooks/useGet';
import Select from 'react-select';
import useGetAuthed from '../../helpers/hooks/useGetAuthed';

const AddProduct = (props) => {
  const history = useHistory();
  const [selectedImage, setSelectedImage] = useState();
  const [categories, , categoriesLoading] = useGetAuthed(
    '/khareedari-categories',
    true
  );
  const [districts, , districtssLoading] = useGet('/districts', true);
  const [companies, , companiesLoading] = useGet('/companies', true);
  const [postProduct, postedData, postingError, dataPosting] = usePost(
    '/khareedari-products'
  );
  const [selectedCategory, setSelectedCategory] = useState();
  const [selectedCompany, setSelectedCompany] = useState();
  const { upload, error, loading: imagesUploading, urls } = useAttachement();

  const handleSubmit = (event, errors, values) => {
    if (dataPosting) {
      return;
    }
    if (
      errors.length > 0 ||
      !selectedImage ||
      !selectedCategory ||
      !selectedCompany
    ) {
      return toastr.warning('Please fix errors in the form');
    }
    const obj = {
      ...values,
      price: parseFloat(values.price),
      khareedariCategoryId: selectedCategory.value,
      companyId: selectedCompany.value,
    };

    upload([selectedImage]).then((_urls) => {
      postProduct({ ...obj, image: _urls[0] });
    });
  };
  useEffect(() => {
    if (postingError) {
      console.log(postingError);
      toastr.error(postingError.error.message);
    }
  }, [postingError]);
  useEffect(() => {
    if (postedData) {
      toastr.success('Product has been added successfully');
      history.push('/supplies/products');
    }
  }, [history, postedData]);
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <AvForm className='needs-validation' onSubmit={handleSubmit}>
            <Row>
              <Col md={{ size: 8, offset: 2 }}>
                <h4>Add New Product</h4>
                <Card>
                  <CardBody>
                    <FormGroup>
                      <Label htmlFor='name'>Name</Label>
                      <AvField
                        name='name'
                        placeholder='Name'
                        type='text'
                        errorMessage='Enter Name'
                        className='form-control'
                        validate={{ required: { value: true } }}
                        id='name'
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label htmlFor='name'>Description</Label>
                      <AvField
                        name='description'
                        placeholder='Description'
                        type='text'
                        errorMessage='Enter Description'
                        className='form-control'
                        validate={{ required: { value: true } }}
                        id='description'
                      />
                    </FormGroup>
                    <FormGroup>
                      <div className='custom-file'>
                        <CustomInput
                          type='file'
                          className='custom-file-input'
                          id='image'
                          accept='image/*'
                          onChange={(e) => {
                            setSelectedImage(e.target.files[0]);
                          }}
                        />
                        <Label className='custom-file-label' htmlFor='image'>
                          {selectedImage ? selectedImage.name : 'Choose Image'}
                        </Label>
                      </div>
                    </FormGroup>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label htmlFor='name'>Price</Label>
                          <AvField
                            name='price'
                            placeholder='Price'
                            type='number'
                            errorMessage='Enter Price'
                            className='form-control'
                            validate={{ required: { value: true } }}
                            id='price'
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label htmlFor='name'>Selling Unit</Label>
                          <AvField
                            name='unit'
                            placeholder='Selling Unit'
                            type='text'
                            errorMessage='Enter Unit'
                            className='form-control'
                            validate={{ required: { value: true } }}
                            id='unit'
                          />
                        </FormGroup>
                      </Col>
                      <Col className=''>
                        <FormGroup>
                          <Label htmlFor='name'>Weight/Qty</Label>
                          <AvField
                            name='weight'
                            placeholder='Weight/Qty'
                            type='text'
                            errorMessage='Enter Weight'
                            className='form-control'
                            validate={{ required: { value: true } }}
                            id='weight'
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label htmlFor='name'>Representative's Phone Number</Label>
                          <AvField
                            name='repPhone'
                            placeholder="Phone Number (923xxxxxxxxxx)"
                            type='text'
                            errorMessage='Please enter the phone number of the representative.'
                            className='form-control'
                            validate={{ 
                              required: { value: true },
                              pattern: { value: '^923' },
                              minLength: { value: 12 },
                              maxLength: { value: 12 }
                            }}
                            id='repPhone'
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <FormGroup>
                      <AvInput
                        tag={CustomInput}
                        type='checkbox'
                        label='Show in Ad'
                        name='showInAd'
                        validate={{ required: { value: false } }}
                      />
                    </FormGroup>
                    <Row>
                      <Col>
                        <FormGroup>
                          <Label>Category</Label>
                          <Select
                            isLoading={categoriesLoading}
                            // value={selectedLanguages}

                            closeMenuOnSelect={true}
                            onChange={(e) => setSelectedCategory(e)}
                            options={
                              categories &&
                              categories.map((x) => ({
                                value: x.id,
                                label: x.name,
                              }))
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col>
                        <FormGroup>
                          <Label>Company</Label>
                          <Select
                            isLoading={companiesLoading}
                            // value={selectedLanguages}

                            closeMenuOnSelect={true}
                            onChange={(e) => setSelectedCompany(e)}
                            options={
                              companies &&
                              companies.map((x) => ({
                                value: x.id,
                                label: x.name,
                              }))
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <FormGroup>
                      <Label>Distrcits</Label>
                      <AvField
                        type='select'
                        name='districtIds'
                        multiple
                        validate={{ required: true }}
                      >
                        {districts?.map((x) => (
                          <option value={x.id}>{x.name}</option>
                        ))}
                      </AvField>
                    </FormGroup>
                  </CardBody>
                </Card>
                <div className='text-right mb-5'>
                  <Button
                    color='primary'
                    disabled={dataPosting || imagesUploading}
                  >
                    {dataPosting || imagesUploading
                      ? 'Saving...'
                      : 'Save Product'}
                  </Button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </Container>
      </div>
    </>
  );
};
export default AddProduct;
